import React from 'react';
import {createSvgIcon} from '@common/icons/create-svg-icon';

export const CustomSquareIcon = createSvgIcon(
  <path d="M 3 6 L 3 26 L 29 26 L 29 6 Z M 5 8 L 27 8 L 27 24 L 5 24 Z " />
);
